// action
import {
    SAVE_PAGE_CONTENT,
    SAVE_PAGE_CONTENT_FAIL,
    SAVE_PAGE_CONTENT_SUCCESS,
    SAVE_PAGE_CONTENT_RESET
} from '../action/savePageContentAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_PAGE_CONTENT:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_PAGE_CONTENT_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_PAGE_CONTENT_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case SAVE_PAGE_CONTENT_RESET:
            return initialState
        default:
            return state
    }
}